import React from 'react';
import { translate } from 'translations/i18n';
import ConfirmationModal from '../../../core/ConfirmationModal';
import { request } from 'javascripts/services/v3ApiClient';
import toast from 'helpers/toast';

export type CancelSampleModalProps = {
  trialId: number;
  onRequestClose: () => void;
  onDelete: () => void;
};

const CancelSampleModal = ({
  trialId,
  onRequestClose,
  onDelete,
}: CancelSampleModalProps) => {
  const deleteTrial = async () => {
    try {
      await request({ url: `accounts/trials/${trialId}`, method: 'delete' });
      toast.success(
        translate('billing.v2.premiumSample.canceledSampleMessage'),
      );
      onDelete();
      // reload the page to re-enable CTAs disabled during trial
      window.location.reload();
    } catch (error) {
      toast.error(
        translate('billing.v2.premiumSample.cancelPremiumSampleError'),
      );
    } finally {
      onRequestClose();
    }
  };

  return (
    <ConfirmationModal
      confirmAction={deleteTrial}
      confirmLabel={translate('billing.v2.premiumSample.cancelModalConfirm')}
      cancelLabel={translate('billing.v2.premiumSample.cancelModalDecline')}
      message={translate('billing.v2.premiumSample.cancelModalBody')}
      title={translate('billing.v2.premiumSample.cancelModalTitle')}
      onRequestClose={onRequestClose}
    />
  );
};

export default CancelSampleModal;
